import $ from 'jquery';
import { Div } from 'leaflet/Layer/Div';
import { Checkbox } from 'leaflet/Layer/Checkbox';
import { Combobox } from 'leaflet/Layer/Combobox';
import { Listbox } from 'leaflet/Layer/Listbox';
import { Textbox } from 'leaflet/Layer/Textbox';
import { Radiobutton } from 'leaflet/Layer/Radiobutton';
import log from 'log';
import * as i18n from 'i18n-setup';
import * as Overlay from 'overlay';
import * as Doc from 'doc';
import style from 'style';
import state from 'state';

var buttons = $('#butApplyChanges').add('#butDiscardChanges'),
    modifiedItems = {};

function applyChanges(){
    log(modifiedItems);
    buttons.hide();
    var params = {
        modifiedItems: JSON.stringify(modifiedItems)
    };

    $.postJSON(state.base + 'setform', params
    ).then(function (data) {
        if ('error' in data) {
            Overlay.error(i18n.str('form.error') + ':\n' + data.error);
            return;
        }
        log(data);
        Doc.updateFiles(data);
    }).catch(function () {
        Overlay.error(i18n.str('form.error') + '.');
    });

    modifiedItems = {};
}

function discardChanges() {
    modifiedItems = {};
    highlight();
    buttons.hide();
}

function getSelectValues(select) {
    var result = [];
    var options = select && select.options;
    var opt;

    for (var i=0, iLen=options.length; i<iLen; i++) {
        opt = options[i];
        if (opt.selected)
            result.push(opt.value || opt.text);
    }
    return result;
}

export function highlight() {

    Doc.layer.form.clearLayers();
    if (state.info.form != null) {
        $.each(state.info.form.completed, function (name, val) {
            var rect;
            var changeCheck = function(e) {
                modifiedItems[name] = e.target.checked;
                buttons.show();
            };

            var changeF = function(e) {
                modifiedItems[name] = e.target.value;
                buttons.show();
            };
            var changeCombo = function(e) {
                log(e);
                modifiedItems[name] = e.target.options[e.target.selectedIndex].value;
                buttons.show();
            };

            var changeList = function(e) {
                log(e);
                modifiedItems[name] = getSelectValues(e.target);
                buttons.show();
            };

            var changeRadio = function(e) {
                modifiedItems[name] = e.target.value;
                buttons.show();
            };


            if (val.type === 'rb') {
                $.each(val.items, function (i, item) {
                    if (item.pos[0] == state.page) {
                        rect = new Radiobutton(Doc.convertPos(item.pos), style.formSaved, changeRadio);
                        rect.setName(name);
                        rect.setValue(item.val);
                        if (val.value == item.val)
                            rect.setChecked();
                        Doc.layer.form.addLayer(rect);
                    }
                });
            } else if (val.position[0] == state.page) {
                if (val.type === 'c') {
                    rect = new Checkbox(Doc.convertPos(val.position), style.formSaved, changeCheck);
                    rect.setValue(val.value);
                } else if (val.type === 't') {
                    rect = new Textbox(Doc.convertPos(val.position), style.formSaved, changeF);
                    rect.setValue(val.value);
                } else if (val.type === 'n') {
                    rect = new Textbox(Doc.convertPos(val.position), style.formSaved, changeF);
                    rect.setValue(val.value);
                    rect.setFormat('number');
                } else if (val.type === 'd') {
                    rect = new Textbox(Doc.convertPos(val.position), style.formSaved, changeF);
                    rect.setValue(val.value);
                    rect.setFormat('date');
                } else if(val.type === 'l'){
                    rect = new Listbox(Doc.convertPos(val.position), style.formSaved, changeList);
                    rect.setOptions(val.displayV, val.exportV);
                    rect.setValue(val.value);
                } else if(val.type === 'cb'){
                    rect = new Combobox(Doc.convertPos(val.position), style.formSaved, changeCombo);
                    rect.setOptions(val.displayV, val.exportV);
                    rect.setValue(val.value);
                } else if(val.type === 'r'){
                    rect = new Div(Doc.convertPos(val.position), style.formSaved);
                }
                Doc.layer.form.addLayer(rect);
            }
        });

        $.each(state.info.form.empty, function (name, val) {
            var rect;

            var changeCheck = function(e) {
                // rect.setValue(!rect.getValue());
                modifiedItems[name] = e.target.checked;
                buttons.show();
                // log('Checkbox cambiata');
                // log(e);
            };

            var changeF = function(e) {
                // rect.setValue(!rect.getValue());
                modifiedItems[name] = e.target.value;
                buttons.show();
                log('Textbox cambiata');
                log(e);
            };

            var changeCombo = function(e) {
                log('Combo changed');
                log(e);
                modifiedItems[name] = e.target.options[e.target.selectedIndex].value;
                buttons.show();
            };

            var changeList = function(e) {
                log(e);
                modifiedItems[name] = getSelectValues(e.target).toString();
                buttons.show();
            };

            var changeRadio = function(e) {
                modifiedItems[name] = e.target.value;
                buttons.show();
            };

            if (val.type === 'rb') {
                log('highlight radiobutton');
                $.each(val.items, function (i, item) {
                    if (item.pos[0] == state.page) {
                        rect = new Radiobutton(Doc.convertPos(item.pos), style.formSaved, changeRadio);
                        rect.setName(name);
                        rect.setValue(item.val);
                        if (val.value == item.val)
                            rect.setChecked();
                        Doc.layer.form.addLayer(rect);
                    }
                });
            } else if (val.position[0] == state.page) {
                if (val.type === 'c') {
                    rect = new Checkbox(Doc.convertPos(val.position), style.formEmpty, changeCheck);
                } else if (val.type === 't') {
                    rect = new Textbox(Doc.convertPos(val.position), style.formEmpty, changeF);
                    //NOT YET IMPLEMENTED ELEMENTS
                } else if (val.type === 'n') {
                    rect = new Textbox(Doc.convertPos(val.position), style.formSaved, changeF);
                    rect.setFormat('number');
                } else if (val.type === 'd') {
                    rect = new Textbox(Doc.convertPos(val.position), style.formSaved, changeF);
                    rect.setFormat('date');
                } else if(val.type === 'l'){
                    // log('EXPORT RICEVUTI:', val.exportV);
                    // log('DISPLAY RICEVUTI:', val.displayV);
                    rect = new Listbox(Doc.convertPos(val.position), style.formEmpty, changeList);
                    rect.setOptions(val.displayV, val.exportV);
                } else if(val.type === 'cb'){
                    // log('COMBO BOX');
                    // log('EXPORT RICEVUTI:', val.exportV);
                    // log('DISPLAY RICEVUTI:', val.displayV);
                    rect = new Combobox(Doc.convertPos(val.position), style.formEmpty, changeCombo);
                    rect.setOptions(val.displayV, val.exportV);
                } else if(val.type === 'r'){
                    rect = new Div(Doc.convertPos(val.position), style.formEmpty);
                }
                Doc.layer.form.addLayer(rect);
            }
        });
    }

}

$('#butApplyChanges').click(applyChanges);
$('#butDiscardChanges').click(discardChanges);
